import React, { useRef, useEffect, useState } from "react";

function VerticalStepper({ activeStep, stepsData }) {
  const steps = stepsData;

  const [dividerHeight, setDividerHeight] = useState("auto");
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const containerHeight = containerRef.current.offsetHeight;
      const numDividers = steps.length - 1;
      const stepHeight = 35; // Assuming each step icon container is 35px high
      const padding = 30 * 2; // Total padding (top + bottom)
      const calculatedHeight = `${
        (containerHeight - padding - stepHeight * steps.length) / numDividers
      }px`;
      setDividerHeight(calculatedHeight);
    }
  }, [steps.length]);

  const stepColor = (index) => {
    const stepsNumber = index + 1;
    if (stepsNumber < activeStep) return "#4CAF50";
    if (stepsNumber === activeStep) return "#E78524";
    return "lightgray";
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      ref={containerRef}
      style={{ paddingTop: "30px", paddingBottom: "30px",height:'100%',flexDirection:'column',maxHeight:'475px' }}
    >
      {steps.map((step, index) => (
        <React.Fragment key={index}>
         <div style={{width:'210px'}}>
         {index !== 0 && (
            <div
              style={{
                width: "3px",
                backgroundColor:
                  index < activeStep ? stepColor(index - 1) : "lightgray",
                height: dividerHeight,
                marginLeft:'17px'
              }}
            ></div>
          )}
          <div
            style={{
              display: "flex",
         
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: ` ${stepColor(index)}` ,
                borderRadius: "100%",
                border: `2px solid ${stepColor(index)}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color:  "white",
              }}
            >
              <div style={{  color: "white",}}>
            {index+1}
              </div>
            </div> &nbsp; &nbsp;
            {/* Optionally, you can add a label under the icon */}
            <span style={{ color: stepColor(index), fontWeight: '600', marginTop: '4px', }}>
              {step.h}
            </span>
          </div>
         </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default VerticalStepper;
